<template>
  <section
    class="bg-gradient-to-r from-gray-100/70 to-gray-100 relative py-8 sm:py-12"
  >
    <div class="container relative">
      <h1 class="text-3xl/tight font-medium mb-4">Ödeme</h1>
    </div>

    <!-- Loading State -->
    <div
      v-if="isLoading"
      class="flex justify-center items-center min-h-[400px]"
    >
      <i class="fas fa-spinner fa-spin text-4xl text-primary"></i>
    </div>

    <!-- Error State -->
    <div v-else-if="errorMessage" class="container">
      <div class="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <i class="fas fa-exclamation-triangle text-red-500 text-4xl mb-4"></i>
        <h2 class="text-xl font-semibold text-red-700 mb-2">
          Sipariş Bulunamadı
        </h2>
        <p class="text-red-600">{{ errorMessage }}</p>
      </div>
    </div>

    <!-- Payment Widget -->
    <div v-else-if="order" class="container">
      <InfoBox
        status="debug"
        text=" Kredi Kartı Numarası : 5526080000000006 
          12/26 123"
      />

      <PaymentWidget
        :order="order"
        :isYearly="isYearly"
        @payment-success="onSuccessfulPayment"
        @payment-error="onPaymentError"
      />
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getOrderById } from "@/services/userServices";
import InfoBox from "@/components/DashboardLayout/dashboard-components/InfoBox.vue";
import PaymentWidget from "@/components/PaymentWidget.vue";

const route = useRoute();
const router = useRouter();

const orderId = ref(route.params.orderId);
const order = ref(null);
const isLoading = ref(true);
const errorMessage = ref("");
const isYearly = ref(true);

onMounted(async () => {
  try {
    const response = await getOrderById(orderId.value);

    if (response && response.Success) {
      order.value = response.Payload;

      // Log the order structure for debugging
      console.log("Order data:", order.value);

      // Validate order structure
      if (!order.value.InvoiceInformation) {
        console.warn("InvoiceInformation is missing from order");
        errorMessage.value = "Fatura bilgileri eksik.";
        return;
      }

      // Determine if yearly based on order items
      if (order.value.OrderItems && order.value.OrderItems.length > 0) {
        isYearly.value = order.value.OrderItems[0].IsYearly || true;
      }
    } else {
      errorMessage.value = response?.Message || "Sipariş bulunamadı.";
    }
  } catch (error) {
    console.error("Error fetching order:", error);
    errorMessage.value = "Sipariş bilgileri alınırken bir hata oluştu.";
  } finally {
    isLoading.value = false;
  }
});

const onSuccessfulPayment = (paymentResult) => {
  // Redirect to payment success page instead of domain selection
  router.push({
    name: "payment-success",
    query: {
      orderId: orderId.value,
      subscriptionId: paymentResult.SubscriptionId,
    },
  });
};

const onPaymentError = (error) => {
  // PaymentWidget already shows the error toast
  console.error("Payment error:", error);
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}
</style>
